import React, { useEffect, useState } from 'react'
import { useGetFileToolsQuery } from '../../Store/Apis/toolsApi'
import Loader from '../Loader/Loader'
import Error from '../Error/Error'

const IconSelector = ({handleIconSelect, iconId}) => {
    const [selectedIcon, setSelectedIcon] = useState('')
    const getFileToolApi = useGetFileToolsQuery()
    const selectIcon = (icon) => {
        setSelectedIcon(icon)
        handleIconSelect(icon)
    }

    useEffect(()=>{
        if(iconId){
            setSelectedIcon({
                id: iconId
            })
        }
    }, [iconId])

    return (
        <>
            {getFileToolApi.isLoading && <Loader height={300} />}
            {getFileToolApi.isError && <Error height={300} />}
            {
                getFileToolApi.isSuccess && (
                    <div className='row g-2'>
                        {
                            getFileToolApi.data.data.map((elem, i) => {
                                return (
                                    <>
                                        <div className="col-md-2 col-sm-2" key={i}>
                                            <div
                                                style={{cursor: 'pointer'}}
                                                className={`customhover1 rounded ${elem.id === selectedIcon.id ? 'selected' : ''}`}
                                                onClick={(event) => selectIcon(elem)}
                                            >
                                                <img
                                                    src={elem.image}
                                                    className={`w-100`}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )
                            })
                        }            
                    </div>
                )
            }
        </>
    )
}

export default IconSelector